export const PRIMARY = '#3b66ff';